import React, { useState } from "react"
import CustomTag from "components/Atoms/CustomTag"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import { useAuthorizationModules } from "hooks/useAuth"
import { useSelectedIds } from "store/selector.redux"
import StatusDialog from "./actions/StatusDialog"

interface DemandActionsProps {
  className?: string
  totalDemands?: number
}
const DemandActions = ({ className, totalDemands }: DemandActionsProps) => {
  const [isStatusOpen, setStatus] = useState(false)
  const demands = useSelectedIds("demands")
  const disabled = useAuthorizationModules("edit", "demand")
  // useMutation(UPDATE)
  function handleClick(action: string) {
    switch (action) {
      case "offline":
        setStatus(true)
        return

      default:
        return
    }
  }
  return (
    <>
      <ActionMenu onClick={handleClick} className={className}>
        <ActionMenuItem
          disabled={disabled}
          icon="offline"
          text="Change Status"
          labelElement={
            <CustomTag minimal intent="success" round>
              {demands?.length || totalDemands}
            </CustomTag>
          }
        />
      </ActionMenu>
      <StatusDialog
        totalDemands={totalDemands}
        isOpen={disabled ? false : isStatusOpen}
        onClose={e => setStatus(false)}
        demands={demands}
      />
    </>
  )
}

export default DemandActions
